'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'rabbit-running';
var width = 576;
var height = 512;
var aliases = ["rabbit-fast"];
var unicode = 'f709';
var svgPathData = 'M449.3 148.5c14.6 2.1 28.7 6.6 41.8 13.5c-.7-35-15-69-40.8-94.2l-1.4-1.4c-1.9-1.9-4.7-2.7-7.3-2.2l-1.6 .3c-2.3 .4-4.2 1.9-5.3 3.9c-7.5-7.7-15.6-14.7-24.3-21.1c5.8-7.3 14.1-12.4 23.5-14.2l1.6-.3c13-2.5 26.4 1.5 35.8 10.8l1.4 1.4c37.1 36.4 55 87.5 49.4 138.2l23.7 17.7c19 14.2 30.2 36.5 30.2 60.3c0 41.5-33.7 75.2-75.2 75.2H406.6l-32 32H424c26.5 0 48 21.5 48 48s-21.5 48-48 48H306.5c-21.2 0-41.6-8.4-56.6-23.4L237 427.9l-66.4 44.3c-22.1 14.7-51.9 8.7-66.6-13.3s-8.7-51.9 13.3-66.6l50.4-33.6-55-55c-9.8-9.8-17.6-21.2-23.1-33.7c-5.7 1.4-11.6 2.2-17.7 2.2c-39.8 0-72-32.2-72-72s32.2-72 72-72c16.3 0 31.3 5.4 43.3 14.5c20.1-18.9 47.1-30.5 76.9-30.5h9c17.3 0 34.4 3.7 50.2 10.9L319 153.9c-5-10.7-8.8-22.1-11.3-33.9l-7.4-34.4c-3.9-18.4 6.6-36.8 24.4-42.7c7.2-2.4 15-2.5 22.3-.3c50.3 15.1 89 55.3 102.3 105.9zM81 239.3c-.7-4.9-1-9.8-1-14.8c0-20.7 5.6-40 15.3-56.7c-6.6-4.7-14.6-7.5-23.3-7.5c-22.1 0-40 17.9-40 40s17.9 40 40 40c3.1 0 6.1-.4 9-1zM135.1 419c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4L214 404.9l-23.1-23.1L135.1 419zM334.8 73.3c-2.4 .8-3.8 3.2-3.2 5.7l7.4 34.4c5.7 26.7 19.7 50.6 39.8 68.5c5.9 5.3 7 14.1 2.7 20.7s-12.8 9.1-20 5.8l-123.3-56c-11.6-5.3-24.2-8-36.9-8h-9c-44.3 0-80.2 35.9-80.2 80.2c0 21.3 8.4 41.7 23.5 56.7L272.6 418.2c9 9 21.2 14.1 33.9 14.1H424c8.8 0 16-7.2 16-16s-7.2-16-16-16H336c-6.5 0-12.3-3.9-14.8-9.9c-.8-1.9-1.2-3.8-1.2-5.8l-2.5-34.7c-2.8-39.5-29.7-73.2-67.5-84.9l-30.7-9.4c-8.4-2.6-13.2-11.6-10.6-20s11.6-13.2 20-10.6l30.7 9.4c50.5 15.5 86.3 60.5 90 113.2l0 .5L388.7 309c3-3 7.1-4.7 11.3-4.7H500.8c23.9 0 43.2-19.3 43.2-43.2c0-13.6-6.4-26.5-17.4-34.6l-37.3-27.9c-15.6-11.7-34.3-18.3-53.6-19.3c-7.1-.3-13.1-5.3-14.8-12.2l-2.1-8.7c-10-40.7-40.8-73.2-81-85.2c-1-.3-2-.3-2.9 0zM480 224.3a16 16 0 1 1 0 32 16 16 0 1 1 0-32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRabbitRunning = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;